import styled from 'styled-components';

export const Header = styled.div`
  ${(props) => props.theme.newTypography.textStyleDisplayMedium}
  padding-bottom: 5px;
  font-weight: 500;
`;

export const SubHeader = styled.div`
  ${(props) => props.theme.newTypography.textStyleBody};
  color: ${(props) => props.theme.newPalette.neutral.N700};
  padding-bottom: 20px;
`;

export const SettingContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SettingTitle = styled.div`
  ${(props) => props.theme.newTypography.textStyleBodyLarge};
`;

export const SettingDescription = styled.div`
  ${(props) => props.theme.newTypography.textStyleBody};
  padding-bottom: 10px;
  color: ${(props) => props.theme.newPalette.neutral.N700};
`;
